import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import Breadcrumbs from '@/uikit/Breadcrumbs/Breadcrumbs';

import styles from './styles.module.scss';

interface AdminPageProps {
  className?: string,
  breadcrumbs?: React.ReactNode [],
}

const AdminPage: FC<PropsWithChildren<AdminPageProps>> = ({
  children,
  className,
  breadcrumbs,
}) => (
  <div className={`${styles.page} ${className || ''}`}>
    {breadcrumbs && (
      <div className={styles.crumbs}>
        <Breadcrumbs>
          {breadcrumbs}
        </Breadcrumbs>
      </div>
    )}
    <div className={styles.content}>
      {children}
    </div>
  </div>
);

export default AdminPage;
